import { createFileRoute } from "@tanstack/react-router";
import { DataCatalogDetailPage } from "../../../components/system/DataCatalogDetailPage";
import { requireSuperAdmin } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/data-catalog/$catalogId/")({
  beforeLoad: requireSuperAdmin(),
  component: DataCatalogDetailRoute,
});

function DataCatalogDetailRoute() {
  const { catalogId } = Route.useParams();
  return <DataCatalogDetailPage catalogId={catalogId} />;
}
